import { render, staticRenderFns } from "./OpusReveal.vue?vue&type=template&id=e318339a&scoped=true&"
import script from "./OpusReveal.vue?vue&type=script&lang=js&"
export * from "./OpusReveal.vue?vue&type=script&lang=js&"
import style0 from "./OpusReveal.vue?vue&type=style&index=0&id=e318339a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e318339a",
  null
  
)

export default component.exports